import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'pptl-modal-offline',
  templateUrl: './modal-offline.component.html',
})
export class ModalOfflineComponent {
  constructor(private modalController: ModalController, private router: Router) {}

  onViewButtonClick() {
    this.router.navigate(['/offline']);

    this.modalController.dismiss();
  }
}
